import { Badge, Box, IconButton } from "@mui/material";
import { NotificationsPopover } from "src/_modules/layouts/components";
import { useState, useEffect, useRef } from "react";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useSocket } from "src/_contexts/socket";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchNotifications,
  notificationReceived,
} from "src/_store/entities/notifications";
import { API_LOADING_STATUSES, notificationRead } from "src/constants";
import { setNotificationSeen } from "src/_store/entities/notifications";
import { useNavigate } from "react-router-dom";
export default function FirstMileNotifications() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const { socket } = useSocket();
  const {
    notifications,
    status: loadingStatus,
    error,
    unreadCount,
    hasNextPage,
    notificationLoading,
  } = useSelector((state) => state.entities.notifications);

  useEffect((_) => {
    dispatch(fetchNotifications({ page: 1, limit: 20 }));
  }, []);

  useEffect(
    (_) => {
      if (socket) {
        socket.on("notification", handleReceivedNotificationFromSocket);
      }
      return (_) =>
        socket &&
        socket.off("notification", handleReceivedNotificationFromSocket);
    },
    [socket, notifications],
  );

  const handleReceivedNotificationFromSocket = (notification) => {
    dispatch(notificationReceived(notification));
  };

  const handleClick = async (event) => {
    setAnchorEl(event.currentTarget);
    // dispatch(clearNotifications());
    dispatch(setNotificationSeen()).unwrap();
    //  dispatch(fetchNotifications({page: 1, limit: 20}))
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const handleNotificationClick = (id) => {
  //     setAnchorEl(null);
  // }

  const handleNotificationClick = async (notification) => {
    // onClick(notification.id)
    setAnchorEl(null);
    if (notification.read !== notificationRead.CLICKED) {
      dispatch(setNotificationSeen(notification.id));
    }
    const { target, id } = notification;
    switch (notification.type) {
      case "ORDER_RESCHEDULE":
        navigate(`/merchant/tasks/order/${target}?notification=${id}`);
        break;
      case "MULTI_ORDERS":
        navigate(`/merchant/orders?orderStatus=UNASSIGNED`);
        break;
      case "SINGLE_ORDER":
        navigate(`/merchant/orders/${target}?notification=${id}`);
        break;
      case "LOCATION":
        navigate(`/merchant/orders/${target}?notification=${id}`);
        break;
      case "ORDER_COMPLETED":
        navigate(`/merchant/orders/${target}?notification=${id}`);
        break;
      case "NEW_TASK":
        navigate(`/merchant/tasks/${target}?notification=${id}`);
        break;
      case "COMMERCIAL_DATA_REJECTED":
        navigate(`/merchant/account/info`);
        break;
      default:
        if (notification.type.includes("CONNECTION")) {
          navigate(`/merchant/connections`);
          break;
        }
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  useEffect(() => {
    loadMore();
  }, []);

  const limit = useRef(20);
  const loadMore = () => {
    dispatch(fetchNotifications({ page: 1, limit: limit.current }));
    limit.current += 20;
  };

  return (
    <Box>
      <IconButton
        disableRipple
        color="inherit"
        sx={{ textTransform: "none" }}
        aria-describedby={id}
        onClick={handleClick}
        size="large"
      >
        <Badge badgeContent={unreadCount} color="danger">
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <NotificationsPopover
        open={open}
        anchorEl={anchorEl}
        notifications={notifications}
        onClose={handleClose}
        handleNotificationClick={handleNotificationClick}
        loading={loadingStatus === API_LOADING_STATUSES.loading}
        error={error}
        loadMore={loadMore}
        hasNextPage={hasNextPage}
        notificationLoading={notificationLoading}
      />
    </Box>
  );
}
